import React from 'react';
import { Modal, ProgressBar } from 'react-bootstrap';
import BankServices from '../../services/BankServices';
import "./Recognition.scss";
import { Message } from '../../locale/Message';

export class RecognitionModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      status: '',
      once: false,
      progress: 0,
      isLoading: false,
    };
  }

  componentDidMount() {
    this.progressCheck();
  }

  componentWillUnmount() {
    this.clearIntervals();
  }

  initProcess() {
    this.timerID = setInterval(
      () => this.progressHandler(),
      1000
    );
    this.timerInstanceId = setInterval(
      () => this.progressCheck(),
      2000,
    )
  }

  clearIntervals() {
    clearInterval(this.timerID);
    clearInterval(this.timerInstanceId);
    clearTimeout(this.timeoutId);
  }

  progressHandler() {
    const { progress } = this.state;

    if (progress < 90) {
      this.setState(prevState => ({
        ...prevState,
        progress: Math.min(prevState.progress + 5, 90)
      }));
    } else if (progress >= 90 && progress < 100) {
      this.setState(prevState => ({
        ...prevState,
        progress: Math.min(prevState.progress + 1, 99)
      }));
    }
  };


  resolover(data) {
    const { onSuccess, onError, handleClose } = this.props;
    this.setState((prev) => ({ ...prev, status: data?.status }));
    switch (data?.status) {
      case 'COMPLETED': {
        this.setState(prev => ({ ...prev, progress: 100 }));
        this.clearIntervals();
        onSuccess(data?.paymentInfo);
        handleClose();
        break;
      }
      case 'FAILED': {
        this.clearIntervals();
        onError();
        handleClose();
        break;
      }
    }
  }

  progressCheck() {
    const { id, onError, handleClose } = this.props;
    const { once } = this.state;
    BankServices.checkProcessRecognition(id)
      .then((res) => {
        if (res?.status !== 'CREATED') {
          if (!once) {
            this.setState((prev) => ({ ...prev, once: true }));
            this.initProcess();
          }
          this.resolover(res);
        } else {
          this.setState((prev) => ({ ...prev, status: res?.status }));
          this.timeoutId = setTimeout(() => this.progressCheck(), 2000);
        }
      })
      .catch((e) => {
        console.error(e);
        this.clearIntervals();
        onError();
        handleClose();
      });
  }

  render() {
    const { isOpen, handleClose, instance, id, lang } = this.props;
    const { status } = this.state;
    const onClose = (id) => {
      this.clearIntervals();
      this.setState((prev) => ({...prev, isLoading: true}));
      BankServices.deleteFileRecognition(id)
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.setState((prev) => ({...prev, isLoading: false}));
          handleClose();
        })
    }

    if (status === 'CREATED') {
      return (
        <Modal show={isOpen} container={instance} bsSize="lg">
          <Modal.Header>
            <div className="recognition-header-root">
              <div className="recognition-header-title-root">
                <span className="recognition-header-title">
                  {Message[lang].loading_recognition_header}
                </span>
              </div>
            </div>
          </Modal.Header>
          <Modal.Body>
            <div className="recognition-body-root">
              <div className="recognition-body-text-root">
                {Message[lang].loading_recognition_init}
              </div>
              <div className="recognition-spinner-root">
                <div className="recognition-spinner" />
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <div className="recognition-footer-root">
              <button
                disabled={this.state.isLoading}
                className="recognition-footer-btn"
                onClick={() => onClose(id)}
              >
                {this.state.isLoading
                  ? Message[lang].loading
                  : Message[lang].cancel}
              </button>
            </div>
          </Modal.Footer>
        </Modal>
      );
    }

    return (
        <Modal show={isOpen} container={instance} bsSize="lg">
          <Modal.Header>
            <div className="recognition-header-root">
              <div className="recognition-header-title-root">
              <span className="recognition-header-title">
                {Message[lang].loading_recognition_header}
              </span>
              </div>
            </div>
          </Modal.Header>
          <Modal.Body>
            <div className="recognition-body-root">
              <div className="recognition-body-text-root">
                {Message[lang].loading_recognition_body}
              </div>
              <ProgressBar bsStyle="info" active now={this.state.progress} />
              <div className="recognition-body-text-root" style={{ textAlign: 'end' }}>
                {this.state.progress}%
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <div className="recognition-footer-root">
              <button disabled={this.state.isLoading} className="recognition-footer-btn" onClick={() => onClose(id)}>
                {this.state.isLoading ? Message[lang].loading : Message[lang].cancel }
              </button>
            </div>
          </Modal.Footer>
        </Modal>
    );
  }
}
